import type { AllRouteEndpoints } from "../routeTypes";
import { cacheKey as teamMembersDataCacheKey } from "../teamMembersData";

export const getCompaniesCompanyIdDevelopersDeveloperIdCacheKey = "/companies/:company_id/developers/:developer_id";
export const getDeveloeprsTableCacheKey = "/companies/:company_id/developers/table";

export const companiesCompanyIdDevelopersDeveloperIdCacheKeys: AllRouteEndpoints[] = [
  // "/companies/:company_id/developers",
  getCompaniesCompanyIdDevelopersDeveloperIdCacheKey,
  getDeveloeprsTableCacheKey,
  // updating a developer can change their team (territory) memberships, so refresh the team members table
  teamMembersDataCacheKey,
];
